import React from "react";
import "./WallentPendding.css";

const Modal = ({ message, onConfirm, onCancel }) => {
  return (
    <div className="fund-modal-backdrop">
      <div className="fund-modal-box">
        <p className="fund-modal-message">{message}</p>
        <div className="fund-modal-buttons">
          <button className="fund-modal-btn confirm" onClick={onConfirm}>Yes</button>
          <button className="fund-modal-btn cancel" onClick={onCancel}>No</button>
        </div>
      </div>  
    </div>
  );
};

export default Modal;
